<header class="header">404 Page Not Found</header>

<p class="header-text">The page you were looking for doesn't exist</p>

<button mat-stroked-button [routerLink]="nav_path.home" type="button">Take Me Home</button>
<button mat-button type="button" (click)="routingService.goBack()">Go Back</button>
